











import { Component, mixins, Prop } from 'nuxt-property-decorator'
import ComponentCategoryItem from '~/components/catalog/category/category-item.vue'
import { ICatalogCategoryItem } from '~/assets/interfaces/catalog'
import MixinGeneral from '~/assets/mixins/general'

@Component({
  components: {
    ComponentCategoryItem,
  },
})
export default class ComponentCatalogCategory extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] })
  readonly categories!: ICatalogCategoryItem[]

  private get visibleCategories(): ICatalogCategoryItem[] {
    const chunkSize = this.$device.isMobileOrTablet ? 3 : 5
    const visibleCount =
      Math.floor(this.categories.length / chunkSize) * chunkSize
    return this.categories.slice(0, visibleCount)
  }
}
